import util from '@bmp-vue/core/api/util'
const controller = 'Auxiliar'
export default Object.assign({}, util.GetCrud(controller, null))
